import { AxiosRequestConfig } from 'axios';
import { store } from 'src/common/redux/configure-store';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { IItemLookup } from '../../../common/interfaces/dtos/IItemLookup';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { IItemLookupCriteria } from './product-lookup';

export enum PolicyLookupNames {
  SellByCode = 'SellByCode',
  LookByCode = 'LookByCode',
  LookupByItemType = 'LookupByItemType',
}

export interface ItemLookupByPolicyResponse {
  itemLookupData: IItemLookup[];
  groupCategory?: string;
}

export const productLookupByPolicy = async (
  criteria: IItemLookupCriteria,
  policy?: PolicyLookupNames,
): Promise<IItemLookup[]> => {
  const policyType = policy || PolicyLookupNames.LookByCode; // Default is look LookByCode.

  const transactionId = store.getState().transaction.transactionId ?? '';
  criteria = { ...criteria, transactionId };

  const itemCode = criteria.scanData?.[0].data;
  const axiosConfig: AxiosRequestConfig = {
    url: `/items/get-item-details/${itemCode}/${policyType}`,
    method: 'POST',
    data: criteria,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
  };

  const response = await emeraldRequest<ItemLookupByPolicyResponse>(emeraldRequestParams);

  return response.itemLookupData;
};

export const getLinkedGroupItems = async (
  criteria: IItemLookupCriteria,
  linkedGroupCode?: string,
): Promise<ItemLookupByPolicyResponse> => {
  const transactionId = store.getState().transaction.transactionId ?? '';
  criteria = { ...criteria, transactionId };

  const axiosConfig: AxiosRequestConfig = {
    url: `/items/get-linked-group-items/${linkedGroupCode}`,
    method: 'POST',
    data: criteria,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<ItemLookupByPolicyResponse>(emeraldRequestParams);
};
